import React from 'react';
import { NavLink } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  LangIcon,
  OrderIcon,
  SettingsIcon,
  ClientIcon,
  ContractIcon,
  MessageIcon,
  CameraIcon,
  SearchIcon,
  UserIcon,
  DownloadIcon,
} from 'icons';
import {
  MANAGER_HD_USAGE_INFO_ROUTE,
  MANAGER_MILLS_VIEW_ROUTE,
  MANAGER_ORDERS_VIEW_ROUTE,
  MANAGER_SETTINGS_ROUTE,
  MANAGER_USERS_VIEW_ROUTE,
  MANAGER_USER_ACTIVITY_ROUTE,
  MANAGER_DEALER_ACTIVITY_ROUTE,
  MANAGER_VIEW_DEALER_CONFIG_RESULT_ROUTE,
  MANAGER_CUSTOMER_ACTIVITY_ROUTE,
  MANAGER_LICENSE_CONTENT_ROUTE,
} from 'constants/routes';

export const ManSidebar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <aside className="sidebar d-md-flex">
      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-users-tooltip" {...props}>
            {t('managerManagement.usersView')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_USERS_VIEW_ROUTE} className="sidebar-link">
          <ClientIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-mills-tooltip" {...props}>
            {t('managerManagement.millsView')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_MILLS_VIEW_ROUTE} className="sidebar-link">
          <LangIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-orders-tooltip" {...props}>
            {t('managerManagement.ordersView')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_ORDERS_VIEW_ROUTE} className="sidebar-link">
          <OrderIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-hd-usage-tooltip" {...props}>
            {t('managerManagement.hdUsageInfo')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_HD_USAGE_INFO_ROUTE} className="sidebar-link">
          <ContractIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-user-activity-tooltip" {...props}>
            {t('managerManagement.userActivity')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_USER_ACTIVITY_ROUTE} className="sidebar-link">
          <MessageIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-dealer-config-tooltip" {...props}>
            {t('managerManagement.dealerConfigTestView')}
          </Tooltip>
        )}
      >
        <NavLink
          to={MANAGER_VIEW_DEALER_CONFIG_RESULT_ROUTE}
          className="sidebar-link"
        >
          <SearchIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-dealer-activity-tooltip" {...props}>
            {t('managerManagement.dealerActivity')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_DEALER_ACTIVITY_ROUTE} className="sidebar-link">
          <CameraIcon />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-customer-activity-tooltip" {...props}>
            {t('managerManagement.customerActivity')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_CUSTOMER_ACTIVITY_ROUTE} className="sidebar-link">
          <UserIcon color="#00000" />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="user-management-tooltip" {...props}>
            {t('dealerManagement.licenseContent')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_LICENSE_CONTENT_ROUTE} className="sidebar-link">
          <DownloadIcon color="#393F4B" />
        </NavLink>
      </OverlayTrigger>

      <OverlayTrigger
        placement="right"
        delay={{ show: 100, hide: 100 }}
        overlay={(props) => (
          <Tooltip id="manager-settings-tooltip" {...props}>
            {t('managerManagement.settings')}
          </Tooltip>
        )}
      >
        <NavLink to={MANAGER_SETTINGS_ROUTE} className="sidebar-link">
          <SettingsIcon />
        </NavLink>
      </OverlayTrigger>
    </aside>
  );
};
